import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import * as React from 'react';
var SvgInformation = React.forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm2.704-23.52V5.184c0-.192-.037-.325-.112-.4s-.208-.112-.4-.112h-4.384c-.192 0-.325.037-.4.112s-.112.208-.112.4V8.48c0 .192.037.325.112.4s.208.112.4.112h4.384c.192 0 .325-.037.4-.112s.112-.208.112-.4zm-5.024 3.136v15.872c0 .192.037.325.112.4s.208.112.4.112h3.616c.192 0 .325-.037.4-.112s.112-.208.112-.4V11.616c0-.192-.037-.325-.112-.4s-.208-.112-.4-.112h-3.616c-.192 0-.325.037-.4.112s-.112.208-.112.4z"
  }));
});
export default SvgInformation;